import { render, staticRenderFns } from "./TagCategoryCreateModal.vue?vue&type=template&id=704b7306"
import script from "./TagCategoryCreateModal.vue?vue&type=script&lang=js"
export * from "./TagCategoryCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports